import { Slot } from '@radix-ui/react-slot';
import { buttonVariants } from '@/components/ui/buttonVariants';
import { cn } from '@/lib/utils';

export function Button({ asChild = false, className, size, type, variant, ...props }) {
  const buttonClassName = cn(buttonVariants({ size, variant }), className);

  if (asChild) {
    return <Slot className={buttonClassName} data-slot="button" {...props} />;
  }

  return <button className={buttonClassName} data-slot="button" type={type ?? 'button'} {...props} />;
}